import React from 'react';

const NotFound = () => {
    return (
        <div style={{minHeight: "400px"}} className='container text-white'>
            <img className='mx-auto d-block img-fluid' src="https://freefrontend.com/assets/img/html-funny-404-pages/HTML-404-Error-Page.gif" alt="" />
        </div>
    );
};

export default NotFound;